function throttle(fn, threshhold, scope) {
  threshhold || (threshhold = 250)
  var last, deferTimer
  return function () {
    var context = scope || this

    var now = +new Date(),
      args = arguments
    if (last && now < last + threshhold) {
      clearTimeout(deferTimer)
      deferTimer = setTimeout(function () {
        last = now
        fn.apply(context, args)
      }, threshhold)
    } else {
      last = now
      fn.apply(context, args)
    }
  }
}

$(document).ready(function () {
  // For onload animations
  $('body').addClass('ready')

  // Scroll based animations
  var els = $('.on-scroll')

  function scrollAnimations() {
    // Scroll position
    var pos = $(window).scrollTop() + $(window).height()

    // fade in
    els.each(function (i) {
      var el = els.eq(i)
      var elPos = el.offset().top

      if (pos > elPos) el.addClass('active')
    })
  }

  scrollAnimations()

  if (els.length) {
    $(window).on(
      'scroll',
      throttle(function () {
        scrollAnimations()
      }, 100)
    )
  }
})
